import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '@shared/config/routes';
import { AppShell } from '@widgets/app-shell';
import { LoginPage } from '@pages/login';
import { ForgotPasswordPage } from '@pages/forgot-password';
import { AcceptInvitePage } from '@pages/accept-invite';
import { DashboardPage } from '@pages/dashboard';
import { AdminsPage } from '@pages/admins';
import { UsersListPage, UserDetailPage } from '@pages/users';
import { ManufacturersListPage, ManufacturerDetailPage } from '@pages/manufacturers';
import { CatalogListPage, ProductDetailPage } from '@pages/catalog';
import { BuyRequestsListPage, BuyRequestDetailPage } from '@pages/buy-requests';
import { CategoriesPage, HsCodesPage } from '@pages/taxonomy';
import { CarriersPage } from '@pages/carriers';
import { AuditPage } from '@pages/audit';
import { SettingsPage } from '@pages/settings';
import { RequireAuth, RequireAnonymous } from './guards';

export function AppRouter() {
  return (
    <Routes>
      <Route
        path={ROUTES.login}
        element={
          <RequireAnonymous>
            <LoginPage />
          </RequireAnonymous>
        }
      />
      <Route
        path={ROUTES.forgotPassword}
        element={
          <RequireAnonymous>
            <ForgotPasswordPage />
          </RequireAnonymous>
        }
      />
      <Route
        path={ROUTES.acceptInvite}
        element={
          <RequireAnonymous>
            <AcceptInvitePage />
          </RequireAnonymous>
        }
      />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path={ROUTES.dashboard} element={<DashboardPage />} />

        <Route path={ROUTES.admins} element={<AdminsPage />} />

        <Route path={ROUTES.users} element={<UsersListPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />

        <Route path={ROUTES.manufacturers} element={<ManufacturersListPage />} />
        <Route path="/manufacturers/:id" element={<ManufacturerDetailPage />} />

        <Route path={ROUTES.catalog} element={<CatalogListPage />} />
        <Route path="/catalog/:id" element={<ProductDetailPage />} />

        <Route path={ROUTES.buyRequests} element={<BuyRequestsListPage />} />
        <Route path="/buy-requests/:id" element={<BuyRequestDetailPage />} />

        <Route path={ROUTES.taxonomy} element={<Navigate to={ROUTES.taxonomyCategories} replace />} />
        <Route path={ROUTES.taxonomyCategories} element={<CategoriesPage />} />
        <Route path={ROUTES.taxonomyHsCodes} element={<HsCodesPage />} />

        <Route path={ROUTES.carriers} element={<CarriersPage />} />
        <Route path={ROUTES.audit} element={<AuditPage />} />
        <Route path={ROUTES.settings} element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.dashboard} replace />} />
    </Routes>
  );
}
